import Axios from "../Axios"
import config from "../../config";

const { api } = config;

export default class API {
    static getToken() {
      const token = window.localStorage.getItem("token");
      return token;
    }

    static completeConsultation(caseId, data) {
        const token = this.getToken();
        return Axios({
            url: `${api.baseUrl}/cases/${caseId}/complete-consultation`,
            data,
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }

    static getCEVLogs(params = {}) {
        const token = this.getToken();
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                searchParams.append(key, value);
            }
        });
        const queryString = searchParams.toString();
        return Axios({
            url: `${api.baseUrl}/cases/cev-logs${queryString ? `?${queryString}` : ''}`,
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }

    static getCEVCategories() {
        const token = this.getToken();
        return Axios({
            url: `${api.baseUrl}/cases/cev-categories`,
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }

    static getCasePrescriptions(caseId, options = {}) {
        const token = this.getToken();
        return Axios({
            url: `${api.baseUrl}/cases/${caseId}/prescriptions`,
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            ...options,
        });
    }

    static registerPDMPView(caseId, resource) {
        const token = this.getToken();
        return Axios({
          url: `${api.baseUrl}/cases/${caseId}/register-pdmp-view`,
            method: "POST",
            data: { resource },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }

    static updateCaseTags(caseId, tags) {
        const token = this.getToken();
        return Axios({
            url: `${api.baseUrl}/cases/${caseId}/tags`,
            method: "PUT",
            data: { tags },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }
}
